export enum GameAge {
  Holocene = 'Holocene',
  // Ancient,
  Postclassical = 'Postclassical',
  Modern = 'Modern',
  Future = 'Future',
}
